import Tooltip from 'src/components/tooltip/Tooltip';
import style from './pulse.module.scss';

export const PulseDot = ({ hideTooltip = false }: { hideTooltip?: boolean }) => {
  if (hideTooltip) {
    return (
      <div className={style.pulseDotContainer}>
        <div className={style.dotBack} />
        <div className={style.dotFront} />
      </div>
    )
  }

  return (
    <Tooltip position={'right'}
        tooltip='Live Now'>
      <div className={style.pulseDotContainer}>
        <div className={style.dotBack} />
        <div className={style.dotFront} />
      </div>
    </Tooltip>
  )
}

export default PulseDot;
